import { Card, CardContent } from "@/components/ui/card";

export default function About() {
  return (
    <div className="container py-16 px-4 md:px-6">
      <div className="max-w-2xl">
        <h1 className="text-4xl font-bold tracking-tight">About Us</h1>
        <p className="mt-4 text-lg text-muted-foreground leading-relaxed">
          Leading manufacturer of textile machinery parts with decades of industry experience
        </p>
      </div>

      <div className="mt-16 grid gap-8 lg:grid-cols-2">
        <div>
          <h2 className="text-2xl font-semibold mb-6">Our Story</h2>
          <p className="text-muted-foreground leading-relaxed mb-6">
            Founded in 2005, we've been at the forefront of textile machinery innovation for 20 years. Our commitment to quality and precision has made us a trusted partner for textile manufacturers worldwide.
          </p>
          <p className="text-muted-foreground leading-relaxed">
            We specialize in manufacturing high-precision parts for various textile machinery applications, from spinning to finishing equipment. Our state-of-the-art facility and expert team ensure the highest quality standards in every component we produce.
          </p>
        </div>
        <div className="aspect-video overflow-hidden rounded-lg shadow-lg">
          <img
            src="https://images.unsplash.com/photo-1558618666-fcd25c85cd64"
            alt="Spinning Mill Machinery"
            className="h-full w-full object-cover"
          />
        </div>
      </div>

      <div className="mt-16">
        <h2 className="text-2xl font-semibold mb-8">Our Team</h2>
        <div className="grid gap-8 sm:grid-cols-2">
          <Card className="shadow-md hover:shadow-lg transition-shadow duration-300">
            <CardContent className="p-6">
              <img
                src="https://images.unsplash.com/photo-1517048676732-d65bc937f952"
                alt="Team"
                className="aspect-video w-full rounded-lg object-cover shadow-sm"
              />
              <h3 className="mt-6 text-xl font-semibold">Expert Engineers</h3>
              <p className="mt-3 text-muted-foreground leading-relaxed">
                Our team of skilled engineers ensures precision in every component we manufacture
              </p>
            </CardContent>
          </Card>
          <Card className="shadow-md hover:shadow-lg transition-shadow duration-300">
            <CardContent className="p-6">
              <img
                src="https://images.unsplash.com/photo-1573496130141-209d200cebd8"
                alt="Quality Control"
                className="aspect-video w-full rounded-lg object-cover shadow-sm"
              />
              <h3 className="mt-6 text-xl font-semibold">Quality Control</h3>
              <p className="mt-3 text-muted-foreground leading-relaxed">
                Rigorous testing and quality control processes for reliable products
              </p>
            </CardContent>
          </Card>

        </div>
      </div>
    </div>
  );
}
